import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ACCESS_LOG_BASE, BackLink, DocumentBundleAccessBatchView } from '../components/views/documentBundleAccessView'

// Sentinel-admin only; the view's API call re-checks `isAdminUser`.
function DocumentBundleAccessBatch() {
    return (
        <div className="documentBundleAccessBatch">
            <Sidebar />
            <MainView>
                <BackLink to={ACCESS_LOG_BASE} text="Back to batches" />
                <ViewTitle text="Bundle Accesses" />
                <DocumentBundleAccessBatchView />
            </MainView>
        </div>
    )
}

export default DocumentBundleAccessBatch
